// extracted by mini-css-extract-plugin
module.exports = {"CommentsButton":"hy_a bfq_vp bfq_iv bfq_wc bfq_i bfq_j bfq_q bfq_um bfq_en bfq_rh bfq_ri bfq_cx","CommentsButton__icon":"hy_b bfq_rc"};